import { postAIWorkEdit, getWorkStatus } from "@/api/work";
import { getWorkInfo } from "@/api";
import store from "@/store";
import { WORKING_STATUS, REDRAW_MODE } from "./consts";
const { dispatch } = store;
const { updateReDrawWorkStatus, updateCurrentReDrawWorkID, updateReDrawWorkQueueInfo, updateCurrentWorkImageItem } = dispatch.work;
let getWorkStatusJobTimer = null;
let workingOver3Sceonds = false;
let workingStartTime = 0;

// 缓存改图数据，下次进入改图时复用
const setCacheWorkParams = (workParams) => {
    delete workParams.smear_coord; // 这个数据太大了，不缓存
    delete workParams.mask_img // mask_img不需要缓存
    delete workParams.work_id; // work_id不缓存
    sessionStorage.setItem('cacheReDrawData', JSON.stringify(workParams));
}

function isImmediateMode(reDrawMode) {
    return reDrawMode === REDRAW_MODE.ERASE || reDrawMode === REDRAW_MODE.REMOVE_WATERMARK;
}

// 发起改图，并在发起后开启任务状态轮询，直到任务完成
const startAIWorkEdit = (workParams, onSuccessCallback, onFailCallBack, cacheWorkParams = true) => {
    workingOver3Sceonds = false;
    workingStartTime = 0;
    if (isImmediateMode(workParams.redraw_mode)) {
        updateReDrawWorkStatus(WORKING_STATUS.START); // 设置成进行中状态，开启改图遮罩
        updateCurrentWorkImageItem({}); // 更新currentWorkImageItem，隐藏图片工具箱
    }
    postAIWorkEdit(workParams).then(res => {
        if (res.status === 200 && res?.data?.result_ok) {
            const workID = res?.data?.work_id;
            if (isImmediateMode(workParams.redraw_mode)) {
                updateCurrentReDrawWorkID(workID);
                updateReDrawWorkStatus(WORKING_STATUS.QUENING); // 更新为排队中状态
                updateReDrawWorkQueueInfo({});
            }
            // 已有轮询任务，则先关闭，避免重复创建
            closeGetWorkStatusJobTimer();
            // 开启任务状态轮询，直到任务完成
            getWorkStatusJobTimer = setInterval(() => {
                getWorkStatus({
                    work_ids: [workID]
                }).then(res => {
                    const list = res?.data || [];
                    if (list.length) {
                        const workItem = list[0];
                        const _isImmediateMode = isImmediateMode(workItem.redraw_mode);
                        if (_isImmediateMode && workItem.img_list?.[0].status === 0){
                            updateReDrawWorkQueueInfo({
                                queue_up: workItem.img_list?.[0].queue_up,
                                vip_queue: workItem.vip_queue
                            });
                        } 
                        // 任务完成
                        if (workItem.status === 1) {
                            closeGetWorkStatusJobTimer();
                            if (_isImmediateMode) updateReDrawWorkStatus(WORKING_STATUS.DONE); // 设置成已完成状态，关闭改图遮罩
                            onSuccessCallback && onSuccessCallback(workItem);
                        } else if (_isImmediateMode) {
                            // 判断img_list是否有创作中的
                            const isWorking = workItem.img_list.some(item => item.status === 3);
                            if (isWorking && !workingStartTime) {
                                // 记下改图开始时间，开始计时
                                workingStartTime = Date.now();
                                updateReDrawWorkStatus(WORKING_STATUS.DOING);
                            }
                            // 判断改图耗时是否超过3s
                            if (!workingOver3Sceonds && workingStartTime && (Date.now() - workingStartTime) >= 3000) {
                                workingOver3Sceonds = true;
                                updateReDrawWorkStatus(WORKING_STATUS.WAITING);
                            }
                        }
                    } else {
                        closeGetWorkStatusJobTimer();
                    }
                })
            }, 1000);
            cacheWorkParams && setCacheWorkParams(workParams);
        } else {
            onFailCallBack && onFailCallBack(res?.msg || res.data?.msg)
        }
    })
}

const closeGetWorkStatusJobTimer = () => {
    getWorkStatusJobTimer && clearInterval(getWorkStatusJobTimer);
    getWorkStatusJobTimer = null;
}

// 判断是否保存了记录或下载了图片
const isSavedWorkRecord = async (workID) => {
    const res = await getWorkInfo({ work_id: workID });
    const isSaved = res?.data?.is_delete;
    return isSaved === 0;
}

// 开启静默作品状态轮询
const startSlientGetWorkStatusJobTimer = (workID, finishCallback)=> {
    const timer = setInterval(() => {
        getWorkStatus({
            work_ids: [workID]
        }).then(res => {
            const list = res?.data || [];
            if (list.length) {
                const workItem = list[0];
                // 任务完成
                if (workItem.status === 1) {
                    clearInterval(timer);
                    finishCallback && finishCallback();
                }
            } else {
                clearInterval(timer);
            }
        })
    }, 1000);
}

// 继续任务状态轮询
const continueGetWorkStatusJobTimer = (workID, onSuccessCallback)=> {
    // 先关闭旧的任务状态轮询
    closeGetWorkStatusJobTimer();
    // 开启任务状态轮询，直到任务完成
    getWorkStatusJobTimer = setInterval(() => {
        getWorkStatus({
            work_ids: [workID]
        }).then(res => {
            const list = res?.data || [];
            if (list.length) {
                const workItem = list[0];
                const _isImmediateMode = isImmediateMode(workItem.redraw_mode);
                if (_isImmediateMode && workItem.img_list?.[0].status === 0){
                    updateReDrawWorkQueueInfo({
                        queue_up: workItem.img_list?.[0].queue_up,
                        vip_queue: workItem.vip_queue
                    });
                } 
                // 任务完成
                if (workItem.status === 1) {
                    closeGetWorkStatusJobTimer();
                    if (_isImmediateMode) updateReDrawWorkStatus(WORKING_STATUS.DONE); // 设置成已完成状态，关闭改图遮罩
                    onSuccessCallback && onSuccessCallback(workItem);
                } else if (_isImmediateMode) {
                    // 判断img_list是否有创作中的
                    const isWorking = workItem.img_list.some(item => item.status === 3);
                    if (isWorking && !workingStartTime) {
                        // 记下改图开始时间，开始计时
                        workingStartTime = Date.now();
                        updateReDrawWorkStatus(WORKING_STATUS.DOING);
                    }
                    // 判断改图耗时是否超过3s
                    if (!workingOver3Sceonds && workingStartTime && (Date.now() - workingStartTime) >= 3000) {
                        workingOver3Sceonds = true;
                        updateReDrawWorkStatus(WORKING_STATUS.WAITING);
                    }
                }
            } else {
                closeGetWorkStatusJobTimer();
            }
        })
    }, 1000); 
}

export {
    setCacheWorkParams,
    startAIWorkEdit,
    isSavedWorkRecord,
    startSlientGetWorkStatusJobTimer,
    closeGetWorkStatusJobTimer,
    continueGetWorkStatusJobTimer
}